import { inject, Injectable } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { isLoginFailedResponse } from "../interfaces/login-failed-response";
import { TokenError } from "../interfaces/token-error";


@Injectable({
    providedIn: 'root'
})
export class LoginErrorNotificationService {
    private readonly snackBar = inject(MatSnackBar);


    public showLoginErrorNotification(error: any) {
        let errorMessage = 'Login fehlgeschlagen';
        if (isLoginFailedResponse(error)) {
            switch (error.error.errorCode) {
                case 'INVALID_CREDENTIALS':
                    errorMessage = 'Ungültige E-Mail Adresse oder Passwort';
                    break;
                case 'INVALID_LESSON_CODE':
                    errorMessage = 'Ungültiger Lesson Code';
                    break;
                case 'NO_LICENCE':
                    errorMessage = 'Kein gültiger Dongle (Codemeter-Stick) erkannt';
                    break;
                case 'ONLY_CODEMETER_ALLOWED':
                    errorMessage = 'Sie sind nicht berechtigt, diese Anwendung zu verwenden (only_codemeter_allowed)';
                    break;
                case 'NOT_ALLOWED':
                    errorMessage = 'Sie sind nicht berechtigt, diese Anwendung zu verwenden';
                    break;
            }
        } else if (error instanceof TokenError) {
            // NOTE: we can create a separate error message in case of token (validation) errors
        }

        return this.snackBar.open(errorMessage, undefined, {
            panelClass: ["snackbar", "error"],
            verticalPosition: 'top',
            duration: 3000,
        }).afterOpened();
    }
}
